export default __webpack_public_path__ + "static/media/benefit_3@2x.274bbc14.png";